export default new class Comment {
  constructor() {
    this.inpField = document.querySelector('.comment-field');
    this.inpName = document.querySelector('.comment-name');
    this.lblName = document.querySelector('.comment-label');
    this.sendBtn = document.querySelector('.send-btn');
    this.msg = document.querySelector('.msg');
    this.msgMobile = document.querySelector('.mobile .msg');
    this.entries = performance.getEntriesByType('navigation');
    this.initBind();

  }

  initBind() {
    this.entries.forEach((entry) => {
      if (entry.type === "reload") {
        this.inpField ? this.inpField.value = '' : '';
        this.inpName ? this.inpName.value = '' : '';
      }
    });
    if (this.inpField) {
      document.addEventListener('click', (e) => {
        if (e.target===this.inpField || e.target===this.inpName ||
              e.target===this.lblName || this.inpField.length > 0 || this.inpName.length > 0) {
          this.focusElement();
        }else {
          this.blurElement();
        }

      })

      this.sendBtn.addEventListener('click', (e) => {
        if (this.inpField.value.length > 0) {
          e.preventDefault();
          this.sendRequest(e);
        } else {
          this.msg.innerText = 'Напишите комментарий';
          this.msg.style.color = "#8A1B14";
          this.msg.style.margin = "-30px 370px 0px 0px";
          this.msg.style.fontWeight = "bold";
          if (document.querySelector('.mobile .msg')) {
            this.msgMobile.style.margin = "-30px 135px 0px 0px";
          }

          this.msg.classList.remove('hidden');
        }
      })
    }
  }

  focusElement() {
    this.sendBtn.classList.remove('hidden');
    this.lblName.classList.remove('hidden');
    this.inpField.style.height = '135px';
    this.inpField.style.setProperty("-webkit-transition", "all .5s ease-in");
    this.inpField.style.setProperty("-moz-transition", "all .5s ease-in");
    this.inpField.style.setProperty("transition", "all .5s ease-in");

  }

  blurElement() {
    if (this.inpField.value.length === 0 && this.inpName.value.length === 0) {
      this.sendBtn.classList.add('hidden');
      this.lblName.classList.add('hidden');
      this.inpField.style.height = '36px';
      this.msg.innerText = '';
      this.msg.classList.add('hidden');
    }

  }

  sendRequest(e) {
    let articleId = e.target.dataset.id;
    $.request('Comment::onSendComment', {
      data: {
        articleId: articleId,
        textComment: this.inpField.value,
        nameComment: this.inpName.value,
      },

      complete: (response) => {
        this.commentHandler(response.responseJSON);
      },
    });
  }

  commentHandler(response) {
    if (response.status === true) {
      this.inpField.value = "";
      this.inpName.value = "";
      this.msg.innerText = "Комментарий успешно отправлен и после модерации будет опубликован на сайте";
      this.msg.style.color = "#1E693A";
      this.msg.style.margin = "-30px 220px 0px 0px";
      this.msg.style.fontWeight = "bold";
      if (document.querySelector('.mobile .msg')) {
        this.msgMobile.style.margin = "-50px 200px 0px 0px";
      }
    } else {
      this.msg.innerText = "Произошла ошибка";
      this.msg.style.color = "#8A1B14";
      this.msg.style.margin = "-30px 370px 0px 0px";
      this.msg.style.fontWeight = "bold";
      if (document.querySelector('.mobile .msg')) {
        this.msgMobile.style.margin = "-30px 135px 0px 0px";
      }
    }
    this.msg.classList.remove('hidden');
  }
}()
